"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTileGroupSliding = void 0;
const React = require("react");
const app_1 = require("app");
const THROTTLE_TIME = 200;
const getItemsPerSlide = () => {
    if ((0, app_1.isDesktop)()) {
        return 3;
    }
    else if ((0, app_1.isTablet)()) {
        return 2;
    }
    else if ((0, app_1.isMobile)()) {
        return 1;
    }
    else {
        return 3;
    }
};
const useTileGroupSliding = (items) => {
    const [activeSlideIndex, setActiveSlideIndex] = React.useState(0);
    const [itemsPerSlide, setItemsPerSlide] = React.useState(getItemsPerSlide());
    const slides = React.useMemo(() => {
        return items.reduce((acc, _, i) => {
            if (i % itemsPerSlide === 0) {
                acc.push(items.slice(i, i + itemsPerSlide));
            }
            return acc;
        }, []);
    }, [items, itemsPerSlide]);
    React.useEffect(() => {
        const handleResize = () => {
            const itemsPerSlide = getItemsPerSlide();
            setItemsPerSlide(itemsPerSlide);
        };
        window.addEventListener('resize', (0, app_1.throttle)(handleResize, THROTTLE_TIME));
        return () => {
            window.removeEventListener('resize', (0, app_1.throttle)(handleResize, THROTTLE_TIME));
        };
    }, []);
    return {
        slides,
        slidesCount: slides.length,
        activeSlideIndex,
        setActiveSlideIndex,
    };
};
exports.useTileGroupSliding = useTileGroupSliding;
